import React, { useEffect } from "react";
import Hrmsbanner from "./Hrmsbanner";
import Hrmsabout from "./Hrmsabout";
import Hrmswhy from "./Hrmswhy";
import Hrmscards from "./Hrmscards";
import Hrmsenquire from "./Hrmsenquire";
import Hrmsfeatures from "./Hrmsfeatures";

const Hrmspage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Hrmsbanner/>

      <Hrmsabout/>
      <Hrmsfeatures/>
      <Hrmswhy/>
      {/* <Hrmsenquire/> */}
      <Hrmscards/>
    </div>
  );
};

export default Hrmspage;
